var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFuelType = function SvgFuelType(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8 6a1 1 0 0 1 1 1h-2a1 1 0 0 1 1-1Zm-3.6 10.6.001 1h.028a2.805 2.805 0 0 0 .209-.012 4.983 4.983 0 0 0 2.066-.65c1.21-.705 2.296-2.086 2.296-4.538V7h-2v5.4c0 1.748-.714 2.467-1.304 2.811a2.985 2.985 0 0 1-1.294.389h-.01a1 1 0 0 0 .008 2v-1Z",
    fill: "#F08200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.653 3C6.931 3 5.4 4.114 5.4 5.639V19.8H4a1 1 0 0 0 0 2h15.6a1 1 0 1 0 0-2h-1.4V5.639C18.2 4.114 16.67 3 14.948 3H8.653ZM9.4 8.4a1 1 0 0 0 0 2h4.8a1 1 0 1 0 0-2H9.4Z",
    fill: "#F08200"
  })));
};
export default SvgFuelType;